import { Component, ViewEncapsulation, Inject, OnDestroy, ChangeDetectionStrategy} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PageService } from "@irb/irb-common/services/page.service";
import { AppService } from "@irb/app.service";
import { TooltipService } from "@irb/irb-common/components/tooltip/tooltip.service";
import { DeleteAssetCategoryDialogGridLayoutService } from "./delete-asset-category-dialog.component.grid-layout.service";
import { IrbSettingsService } from "@irb/irb-settings/irb-settings.service";
import { takeUntil } from "rxjs/operators";
import { ReplaySubject, Subscription } from "rxjs";
import { IrbSettingsEvents } from "@irb/irb-common/events";
import { IGlobalSettings, IPortfolioCustomCategory } from "@irb/irb-settings/irb-settings.model";

@Component({ standalone: false,
  templateUrl: './delete-asset-category-dialog.component.html',
  styleUrls: ['./delete-asset-category-dialog.component.scss', '../../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DeleteAssetCategorydialogComponent implements OnDestroy {
  gridOptions: any;
  grid: any;
  frameworkComponents: any;
  sigleVCatIDs: any;
  globalSettings: IGlobalSettings;
  selectedCategoryCount: number;
  private _securityCustomCategories: Array<any> = [];
  _originalSecurityCustomCategories: Array<any> = [];
  eventSubscription: Subscription;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(public dialogRef: MatDialogRef<DeleteAssetCategorydialogComponent>,
    public ps: PageService,
    public as: AppService,
    public tts: TooltipService,
    public iss: IrbSettingsService,
    private gls: DeleteAssetCategoryDialogGridLayoutService,
    @Inject(MAT_DIALOG_DATA) public mdd: any,
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(this),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No Rows.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onGridReady(params: any) {
    this.grid = params;
    this.iss.getGlobalSettings().pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.loadGrid();
      this.load(data as IGlobalSettings);
    });
  }

  loadGrid() {
    if(this.mdd.catIds.length > 1){
      this.iss.checkCategoryRestrictions(this.mdd.catIds).pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
        this.securityCustomCategories = data.responseData;
        this.selectedCategoryCount = this.securityCustomCategories.length;
      });
    }if(this.mdd.catIds.length == 1){
      this.iss.checkCategoryRestrictions(this.mdd.catIds).pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
        this.securityCustomCategories = data.responseData;
      });
    }
    else{
      this.iss.checkCategoryRestrictions([this.mdd.catIds]).pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
        this.securityCustomCategories = data.responseData;
      });
    }
  }

  load(data: IGlobalSettings) {
    this.globalSettings = data;
  }

  close() {
    this.tts.remove();
    this.dialogRef.close();
  }

  continue() {
    if (this.mdd.catIds.length > 1) {
      this.as.fireEvent(IrbSettingsEvents.DELETE_ASSET_CATEGORY);
      this.as.fireEvent(IrbSettingsEvents.DELETE_ASSET_REMOVE_ALL);
    }
    else {
        this.as.fireEvent(IrbSettingsEvents.CHECK_RESTRICTION_DELETE_CATEGORY, this.sigleVCatIDs);
        this.as.fireEvent(IrbSettingsEvents.DELETE_ASSET_CATEGORY_SINGLE, {categoryId: this.mdd.catIds[0]});  
   }
   if(this.mdd.cbFunc){
     this.mdd.cbFunc();
   }
    this.tts.remove();
    this.dialogRef.close();
  }

  public get securityCustomCategories(): Array<IPortfolioCustomCategory> {
    return this._securityCustomCategories;
  }

  public set securityCustomCategories(value: Array<IPortfolioCustomCategory>) {
    this._securityCustomCategories = value;
  }
  
  get originalSecurityCustomCategories(): Array<any> {
    return this._originalSecurityCustomCategories;
  }

  set originalSecurityCustomCategories(n: Array<any>) {
    this._originalSecurityCustomCategories = n;
  }
}
